import { useState } from 'react';
import { arrayOf, func, object } from 'prop-types';
import {
  Box,
  Fab,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from '@material-ui/core';
import {
  HelpOutline as HelpOutlineIcon,
  PlayCircleOutline as PlayCircleOutlineIcon,
} from '@material-ui/icons';

/**
 * Botón flotante de ayuda. Al presionarlo ofrece los tours de la pantalla; si
 * hay más de uno, se listan por tema para no obligar al recorrido completo.
 *
 * Va fijo abajo a la derecha: notistack usa la esquina opuesta, así que no se
 * encima con los avisos.
 */
function TourFab({ onStart, tours }) {
  const [anchor, setAnchor] = useState(null);

  if (!tours.length) {
    return null;
  }

  return (
    <Box>
      <Tooltip placement="left" title="Ayuda y recorridos guiados">
        <Fab
          aria-label="Ayuda y recorridos guiados"
          color="primary"
          size="medium"
          style={{
            bottom: 24,
            position: 'fixed',
            right: 24,
            zIndex: 1200,
          }}
          onClick={(event) => setAnchor(event.currentTarget)}
        >
          <HelpOutlineIcon />
        </Fab>
      </Tooltip>

      <Menu
        anchorEl={anchor}
        keepMounted={false}
        open={Boolean(anchor)}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'top',
        }}
        getContentAnchorEl={null}
        transformOrigin={{
          horizontal: 'right',
          vertical: 'bottom',
        }}
        onClose={() => setAnchor(null)}
      >
        <Box style={{
          padding: '4px 16px 8px',
        }}>
          <Typography variant="overline" color="textSecondary">
            {tours.length > 1 ? 'Recorridos guiados' : 'Recorrido guiado'}
          </Typography>
        </Box>

        {tours.map((tour) => (
          <MenuItem
            key={tour.id}
            style={{
              maxWidth: 330,
              whiteSpace: 'normal',
            }}
            onClick={() => {
              setAnchor(null);
              onStart(tour.id);
            }}
          >
            <PlayCircleOutlineIcon color="primary" style={{
              flexShrink: 0,
              marginRight: 12,
            }} />
            <ListItemText
              primary={tour.name}
              primaryTypographyProps={{
                style: {
                  fontWeight: 600,
                },
                variant: 'body2',
              }}
              secondary={tour.description}
              secondaryTypographyProps={{
                variant: 'caption',
              }}
            />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}

TourFab.defaultProps = {
  tours: [],
};

TourFab.propTypes = {
  onStart: func.isRequired,
  tours: arrayOf(object),
};

export default TourFab;
